import React, { useState } from "react";
import logo from "../assets/img/rsilogo.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/Store"; // Adjust the import path to where RootState is defined
import useScrollToTop from "./useScrollToTop";

const Navbar = ({ current }: { current: string }) => {
  useScrollToTop();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const State = useSelector((state: RootState) => state);

  const favouriteFoods = State.FavouriteFood.quoteItems;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav className="bg-white font-serif z-50 fixed top-0 shadow-lg w-full">
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex w-full items-center justify-evenly h-[5rem] py-5 md:px-2 pr-7">
            <div className="flex justify-evenly items-center w-full">
              <div className="text-primary text-xl font-bold md:ml-2">
                <Link to={"/"}>
                  <img
                    src={logo}
                    alt="Logo"
                    className="md:w-[8.4%] w-[18%] rounded-[0.3rem] mr-[7rem]"
                  />
                </Link>
              </div>
              <div className="hidden lg:block">
                <ul className="lg:ml-[-16rem] lg:mr-[11rem] flex items-center space-x-4">
                  <Link to={"/"}>
                    <li
                      className={`${
                        current === "home" ? "text-primary" : "text-gray-900"
                      } hover:text-primary-dbg-primary-dark px-3 py-2 rounded-md text-lg font-medium`}
                    >
                      Home
                    </li>
                  </Link>
                  <Link to={"/about"}>
                    <li
                      className={`${
                        current === "about" ? "text-primary" : "text-gray-900"
                      } hover:text-primary-dbg-primary-dark px-3 py-2 rounded-md text-lg font-medium`}
                    >
                      About
                    </li>
                  </Link>
                  <Link to={"/contact"}>
                    <li
                      className={`${
                        current === "contact" ? "text-primary" : "text-gray-900"
                      } hover:text-primary-dbg-primary-dark px-3 py-2 rounded-md text-lg font-medium`}
                    >
                      Contact
                    </li>
                  </Link>
                  <Link to={"/products"}>
                    <li
                      className={`${
                        current === "products"
                          ? "text-primary"
                          : "text-gray-900"
                      } hover:text-primary-dbg-primary-dark px-3 py-2 rounded-md text-lg font-medium`}
                    >
                      Products
                    </li>
                  </Link>
                  <Link to={"/blog"}>
                    <li
                      className={`${
                        current === "blog" ? "text-primary" : "text-gray-900"
                      } hover:text-primary-dbg-primary-dark px-3 py-2 rounded-md text-lg font-medium`}
                    >
                      Blog
                    </li>
                  </Link>
                  <Link to={"/cart"}>
                    <li
                      className={`${
                        current === "cart" ? "text-primary" : "text-gray-900"
                      } hover:text-primary-dbg-primary-dark px-3 py-2 rounded-md text-lg font-medium flex gap-1 items-center`}
                    >
                      Cart{" "}
                      {favouriteFoods.length > 0 && (
                        <span className="bg-primary text-white w-5 h-5 mt-[-4vh] flex items-center justify-center rounded-full text-xs">
                          {favouriteFoods?.length}
                        </span>
                      )}
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
            <div className="-mr-7 ml-3 lg:hidden">
              <button
                onClick={toggleMenu}
                className="inline-flex items-center justify-center p-2 rounded-md text-black hover:text-primary-dark focus:outline-none"
              >
                <svg
                  className="h-6 w-6"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className={!isMenuOpen ? "block" : "hidden"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                  <path
                    className={isMenuOpen ? "block" : "hidden"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden ${
            isMenuOpen ? "block" : "hidden"
          } z-50 fixed w-full bg-white`}
        >
          <ul className="px-2 pt-2 pb-3 space-y-8 sm:px-3 h-[90vh]">
            <Link to={"/"}>
              <li className="text-black hover:bg-primary-dark hover:text-white block px-3 py-4 rounded-md text-base font-medium">
                Home
              </li>
            </Link>
            <Link to={"/about"}>
              <li className="text-black hover:bg-primary-dark hover:text-white block px-3 py-4 rounded-md text-base font-medium">
                About
              </li>
            </Link>

            <Link to={"/products"}>
              <li className="text-black hover:bg-primary-dark hover:text-white block px-3 py-4 rounded-md text-base font-medium">
                Products
              </li>
            </Link>

            <Link to={"/cart"}>
              <li className="text-black hover:bg-primary-dark hover:text-white block px-3 py-4 rounded-md text-base font-medium">
                Cart
              </li>
            </Link>

            <Link to={"/blog"}>
              <li className="text-black hover:bg-primary-dark hover:text-white block px-3 py-4 rounded-md text-base font-medium">
                Blog
              </li>
            </Link>

            <Link to={"/contact"}>
              <li className="text-black hover:bg-primary-dark hover:text-white block px-3 py-4 rounded-md text-base font-medium">
                Contact
              </li>
            </Link>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
